// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__nuxt{width:100%}.page-fade{animation-duration:.5s}.error-modal{margin:0 auto;max-width:400px;padding:20px;text-align:center}.error-modal .error-icon{font-size:48px;line-height:1;margin-bottom:15px}.error-modal h3{font-size:24px;font-weight:700;margin:10px 0}.error-modal h4{color:#666;font-size:18px;font-weight:400;margin:10px 0 15px}.error-modal p{line-height:1.5;margin:0}.general-error .error-icon{color:#f39c12}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
